/* eslint-disable react/no-array-index-key */
import { FC } from 'react';
import { CustomMovement, Note, Observation } from 'types';

import PartnerObservationsSection from './PartnerObservationsSection';
import PartnerNotesSection from './PartnerNotesSection';
import PartnerCustomMovementsSection from './PartnerCustomMovementsSection';

type PartnerObservationsProps = {
  partnerId: string;
  notes: Note[];
  observations: Observation[];
  customMovements?: CustomMovement[];
};

const PartnerObservations: FC<PartnerObservationsProps> = ({
  partnerId,
  notes,
  observations,
  customMovements,
}) => (
  <>
    <PartnerNotesSection partnerId={partnerId} notes={notes} />
    <PartnerObservationsSection observations={observations} />
    <PartnerCustomMovementsSection customMovements={customMovements} />
  </>
);

export default PartnerObservations;
